import React, { Component } from 'react';
import '../css/App.css';
import API from '../config_api'
import axios from 'axios'
import Sidenav from './Sidenav'

class Groups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };

    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/')
        }
        let formData = new FormData();
        formData.append('userid', localStorage.getItem('token'))
        axios({
            method: 'post',
            url: API.Groups,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                console.log(res.data.data)

                this.setState({ data: res.data.data })

            });
    }
    btnAction(data) {
        console.log(data);
        this.props.history.push('/group/' + data.group_id, { data })
        localStorage.setItem('group_name', data.group_name)
    }


    render() {
        return (
            <div className="">
                <Sidenav type={'second'} url={'/dashboard'} />

                <div className="container">
                    <div className="row">

                        <div className="col-md-12 text-center" style={{ padding: 15 }}>
                            <h5 className="size-text">Groups</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 ">
                            {this.state.data.map((data, i) =>
                                <div className="row" style={{ margin: '10px 0' }} key={i} onClick={() => this.btnAction(data)}>
                                    <div className="card mZero flex-row align-item-center col-md-12"   >
                                        <div className="col-md-2 text-center"><i class="fa fa-users" aria-hidden="true" style={{fontSize:'40px'}}></i><span style={{
                                            position: 'relative',
                                            top: -21,
                                            left: 7
                                        }}>{data.members}</span></div>
                                        <div className="col-md-8"><h4 className=" mZero" >{data.group_name}</h4><p className="mZero">{data.facilitator_name ? data.facilitator_name : 'No Facilitator'} - {data.topic_count} topic(s)</p> </div>

                                        <div className="col-md-2 text-right"> <i className="material-icons">
                                            keyboard_arrow_right
                 </i></div>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div></div></div>
        )
    }
}
export default Groups;